<template>
  <div class="container">
    <p class="title">{{ title }}</p>
    <div contenteditable class="input-container">
      <div style="width: 100%"><slot>-</slot></div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
export default {
  props: ["title"],
};
</script>

<style lang="scss" scoped>
.input-container {
  border-radius: 5px;
  border: 1px solid #e2e1e5;
  background: #ebebeb;
  display: flex;
  padding: 7px 10px;
  justify-content: space-between;

  align-self: stretch;
}
.input {
  padding: 10px;
}
.container {
  display: flex;
  padding-bottom: 15px;
  flex-direction: column;
  width: 100%;
}
.container * {
  margin: 0px;
}
.title {
  color: #7b7b7b;
  font-size: 11px;
  padding-bottom: 4px;
  font-weight: 700;
  line-height: 120%; /* 13.2px */
}
</style>
